var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { "ml-3": "", "px-3": "", "py-0": "" } },
    [
      _c(
        "v-layout",
        { attrs: { row: "", wrap: "" } },
        [
          _vm.hasFilter && _vm.coApartments.length
            ? _c(
                "v-flex",
                {
                  attrs: {
                    xs4: "",
                    md3: "",
                    "mt-4": "",
                    "mb-3": "",
                    "mr-3": ""
                  }
                },
                [
                  _c(
                    "base-condition-selector",
                    {
                      attrs: {
                        items: _vm.coApartments,
                        "on-fetch": _vm.handleApartmentRemoteFetch,
                        label: _vm.$t(_vm.lblSetting.ticketAppartement),
                        "set-loader-state": _vm.setFilterLoaderState
                      },
                      model: {
                        value: _vm.fKTicketApartment,
                        callback: function($$v) {
                          _vm.fKTicketApartment = $$v
                        },
                        expression: "fKTicketApartment"
                      }
                    },
                    [
                      _c(
                        "template",
                        { slot: "loader" },
                        [_c("ticket-list-filters-loaders")],
                        1
                      )
                    ],
                    2
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "v-flex",
            { attrs: { xs4: "", md3: "", "mt-4": "", "mb-3": "" } },
            [
              _c("base-search-selector", {
                attrs: {
                  items: _vm.coStates,
                  label: _vm.$t(_vm.lblSetting.ticketState),
                  multiple: ""
                },
                model: {
                  value: _vm.fkTicketState,
                  callback: function($$v) {
                    _vm.fkTicketState = $$v
                  },
                  expression: "fkTicketState"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-flex",
        { attrs: { md12: "" } },
        [
          _c(
            "base-infinity-loading",
            {
              attrs: {
                pagination: _vm.pagination,
                "default-container": false,
                activityStatus: _vm.activityStatus,
                parameter: _vm.coSearchParameter,
                source: _vm.ticketViewModels,
                "on-fetch": _vm.storeGetTickets,
                "reset-before-destroy": _vm.storeResetTickets,
                "set-loader-state": _vm.setTicketLoaderState
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(row) {
                    return [_c("list-item", { attrs: { ticket: row.data } })]
                  }
                }
              ])
            },
            [
              _c("template", { slot: "loader" }, [
                _c(
                  "div",
                  { staticClass: "mt-3 ml-5" },
                  _vm._l(3, function(n) {
                    return _c("ticket-list-loader", { key: n })
                  }),
                  1
                )
              ])
            ],
            2
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1db58e98", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1db58e98","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/containers/block/block-tickets/template.html
// module id = null
// module chunks = 